import {http, HttpResponse} from 'msw';

import {buildMockAuctionDetail, buildMockAuctionListResponse} from './buildMockAuctionListResponse';

export const sourcingAuctionApiMock = [
  http.post('*/dms/v1/auction-vehicle/_count', () => HttpResponse.json({count: 6})),

  http.post('*/dms/v1/auction-vehicle', () => HttpResponse.json(buildMockAuctionListResponse())),

  http.get('*/dms/v1/auction-vehicle/:externalId', ({params}) => {
    const found = buildMockAuctionDetail(String(params.externalId));
    if (!found) {
      return new HttpResponse(null, {status: 404});
    }
    return HttpResponse.json(found);
  }),
];
